import React, { useState } from 'react';
import './App.css';
import Login from './components/auth/Login';
import DebugComponent from './components/DebugComponent';
// import Dashboard from './pages/Dashboard';
// import Layout from './components/layout/Layout';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);

  const handleLogin = (userData) => {
    setIsAuthenticated(true);
    setUser(userData);
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    setUser(null);
  };
<DebugComponent />
  return (
    <div className="App">
      {!isAuthenticated ? (
        <Login onLogin={handleLogin} />
      ) : (
        <div className="dashboard-container">
          <h1>Welcome to Purchasing System</h1>
          <p>Hello, {user?.username}!</p>
          <p>Authentication Status: {isAuthenticated ? 'Logged In' : 'Not Logged In'}</p>
          
          <div className="dashboard-content">
            <h2>Dashboard Will Go Here</h2>
            <button onClick={handleLogout} className="logout-button">
              Logout
            </button>
            {/* <Layout user={user} onLogout={handleLogout} /> */}
          </div>
        </div>
      )}
    </div>
  );
}

export default App;